import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminLayout from '../components/SuperAdminLayout';
import '../styles/superadmin.css';

const BASE = 'https://menu.searchisend.in';

const AddCustomer = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('saas_superadmin_token');
    const userString = localStorage.getItem('saas_superadmin_user');
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    
    const [formData, setFormData] = useState({
        restaurant_name: '',
        menu_slug: '',
        username: '',
        password: '',
        email: '',
        enable_free_trial: false,
        trial_period: '7',
        custom_trial_days: '',
        renewal_date: new Date().toISOString().split('T')[0],
        has_offer_popup: false,
        has_coupon_system: false,
        has_push_notification: false,
        has_staff_management: false,
        has_ad_monetization: false,
        has_loyalty_system: false,
        logo_image: null,
        phone_for_orders: '',
        social_whatsapp: '',
        social_instagram: '',
        social_facebook: '',
        social_youtube: '',
        review_link: '',
        upi_id: '',
        upi_payee_name: ''
    });

    useEffect(() => {
        if (!token || !userString) {
            navigate('/superadmin_v2_secure_login');
        }
    }, [token, userString, navigate]);

    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked }));
        } else if (type === 'file') {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        const submitData = new FormData();
        Object.keys(formData).forEach(key => {
            if (key === 'logo_image') {
                if (formData[key]) submitData.append(key, formData[key]);
            } else if (typeof formData[key] === 'boolean') {
                submitData.append(key, formData[key] ? '1' : '0');
            } else {
                submitData.append(key, formData[key]);
            }
        });

        try {
            const res = await fetch(`${BASE}/apimenu/v2/v2_super_dashboard.php?action=add_customer`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: submitData
            });
            const data = await res.json();
            
            if (data.success) {
                setSuccess('Customer created successfully!');
                setTimeout(() => {
                    navigate('/superadmin_v2_secure');
                }, 1500);
            } else {
                setError(data.message || 'Error creating customer.');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <SuperAdminLayout>
                    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                        <div style={{ marginBottom: '2rem' }}>
                            <h2 className="sa-page-title">Add New Partner</h2>
                            <p className="sa-page-subtitle" style={{ margin: 0 }}>Create a new restaurant account and provision their initial setup.</p>
                        </div>
                        
                        {error && <div style={{ background: 'var(--danger-bg)', color: 'var(--danger)', padding: '12px 16px', borderRadius: 'var(--radius-sm)', marginBottom: '20px', border: '1px solid var(--danger)', fontWeight: 500 }}><i className="fas fa-exclamation-circle"></i> {error}</div>}
                        {success && <div style={{ background: 'var(--success-bg)', color: 'var(--success)', padding: '12px 16px', borderRadius: 'var(--radius-sm)', marginBottom: '20px', border: '1px solid var(--success)', fontWeight: 500 }}><i className="fas fa-check-circle"></i> {success}</div>}
                        
                        <form onSubmit={handleSubmit}>
                            {/* LOGIN & LINK DETAILS */}
                            <div className="sa-panel">
                                <h3 className="sa-panel-title"><i className="fas fa-user-circle"></i> Account Configuration</h3>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Restaurant Name</label>
                                        <input type="text" name="restaurant_name" className="sa-input" style={{ width: '100%' }} value={formData.restaurant_name} onChange={handleInputChange} required />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Public Menu Link Name <span style={{fontWeight: 'normal', color: 'var(--text-secondary)'}}>(e.g., grill-inn)</span></label>
                                        <input type="text" name="menu_slug" className="sa-input" style={{ width: '100%' }} value={formData.menu_slug} onChange={handleInputChange} required />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Admin Panel Username</label>
                                        <input type="text" name="username" className="sa-input" style={{ width: '100%' }} value={formData.username} onChange={handleInputChange} required />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Admin Panel Password</label>
                                        <input type="password" name="password" className="sa-input" style={{ width: '100%' }} value={formData.password} onChange={handleInputChange} required />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Customer Email <span style={{fontWeight: 'normal', color: 'var(--text-secondary)'}}>(For Receipts)</span></label>
                                        <input type="email" name="email" className="sa-input" style={{ width: '100%' }} value={formData.email} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </div>

                            {/* SUBSCRIPTION */}
                            <div className="sa-panel">
                                <h3 className="sa-panel-title"><i className="fas fa-id-card"></i> Subscription Math</h3>
                                
                                <div style={{ padding: '1rem', background: 'var(--bg-dark)', borderRadius: 'var(--radius-sm)', marginBottom: '1rem' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, color: 'var(--text-primary)', cursor: 'pointer' }}>
                                        <input type="checkbox" name="enable_free_trial" style={{ transform: 'scale(1.2)' }} checked={formData.enable_free_trial} onChange={handleInputChange} />
                                        Enable Free Trial Mode? (Overrides Manual Date)
                                    </label>
                                </div>

                                {formData.enable_free_trial ? (
                                    <div style={{ display: 'flex', gap: '15px', alignItems: 'center', paddingLeft: '1rem' }}>
                                        <div style={{ flex: 1 }}>
                                            <label className="sa-form-label">Trial Period</label>
                                            <select name="trial_period" className="sa-select" style={{ width: '100%' }} value={formData.trial_period} onChange={handleInputChange}>
                                                <option value="2">2 Days</option>
                                                <option value="4">4 Days</option>
                                                <option value="7">7 Days</option>
                                                <option value="custom">Custom</option>
                                            </select>
                                        </div>
                                        {formData.trial_period === 'custom' && (
                                            <div style={{ flex: 1 }}>
                                                <label className="sa-form-label">Enter Custom Days</label>
                                                <input type="number" name="custom_trial_days" className="sa-input" style={{ width: '100%' }} value={formData.custom_trial_days} onChange={handleInputChange} min="1" />
                                            </div>
                                        )}
                                        <div style={{ flex: 2 }}>
                                            <p style={{ fontSize: '0.85rem', color: 'var(--info)', margin: 0, padding: '10px', background: 'var(--info-bg)', borderRadius: 'var(--radius-sm)' }}><i className="fas fa-info-circle"></i> Premium features (Offers, Coupons, Push) are auto-enabled during trials.</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Manual Subscription Renewal Date</label>
                                        <input type="date" name="renewal_date" className="sa-input" style={{ width: '100%' }} value={formData.renewal_date} onChange={handleInputChange} />
                                    </div>
                                )}
                            </div>

                            {/* PREMIUM FEATURES */}
                            {!formData.enable_free_trial && (
                                <div className="sa-panel">
                                    <h3 className="sa-panel-title"><i className="fas fa-crown"></i> Premium Features</h3>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, cursor: 'pointer', background: 'var(--bg-dark)', padding: '1rem', borderRadius: 'var(--radius-sm)' }}>
                                            <input type="checkbox" name="has_offer_popup" style={{ transform: 'scale(1.2)' }} checked={formData.has_offer_popup} onChange={handleInputChange} />
                                            Offer Popup
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, cursor: 'pointer', background: 'var(--bg-dark)', padding: '1rem', borderRadius: 'var(--radius-sm)' }}>
                                            <input type="checkbox" name="has_coupon_system" style={{ transform: 'scale(1.2)' }} checked={formData.has_coupon_system} onChange={handleInputChange} />
                                            Coupon Engine
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, cursor: 'pointer', background: 'var(--bg-dark)', padding: '1rem', borderRadius: 'var(--radius-sm)' }}>
                                            <input type="checkbox" name="has_push_notification" style={{ transform: 'scale(1.2)' }} checked={formData.has_push_notification} onChange={handleInputChange} />
                                            Push Notifications
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, cursor: 'pointer', background: 'var(--bg-dark)', padding: '1rem', borderRadius: 'var(--radius-sm)' }}>
                                            <input type="checkbox" name="has_loyalty_system" style={{ transform: 'scale(1.2)' }} checked={formData.has_loyalty_system} onChange={handleInputChange} />
                                            Loyalty Program
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, cursor: 'pointer', background: 'var(--bg-dark)', padding: '1rem', borderRadius: 'var(--radius-sm)' }}>
                                            <input type="checkbox" name="has_staff_management" style={{ transform: 'scale(1.2)' }} checked={formData.has_staff_management} onChange={handleInputChange} />
                                            Staff Management
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 600, cursor: 'pointer', background: 'var(--bg-dark)', padding: '1rem', borderRadius: 'var(--radius-sm)' }}>
                                            <input type="checkbox" name="has_ad_monetization" style={{ transform: 'scale(1.2)' }} checked={formData.has_ad_monetization} onChange={handleInputChange} />
                                            Ad Monetization
                                        </label>
                                    </div>
                                </div>
                            )}

                            {/* DETAILS AND SOCIALS */}
                            <div className="sa-panel">
                                <h3 className="sa-panel-title"><i className="fas fa-info-circle"></i> Restaurant Details & Socials</h3>
                                <div className="sa-form-group">
                                    <label className="sa-form-label">Restaurant Logo (Optional)</label>
                                    <input type="file" name="logo_image" accept="image/*" onChange={handleInputChange} className="sa-input" style={{ width: '100%', background: 'white' }} />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                    <div className="sa-form-group" style={{ display: 'none' }}>
                                        <label className="sa-form-label">Phone for Orders</label>
                                        <input type="text" name="phone_for_orders" className="sa-input" style={{ width: '100%' }} placeholder="+91..." value={formData.phone_for_orders} onChange={handleInputChange} />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">WhatsApp Number</label>
                                        <input type="text" name="social_whatsapp" className="sa-input" style={{ width: '100%' }} placeholder="e.g. 919876543210" value={formData.social_whatsapp} onChange={handleInputChange} />
                                    </div>
                                </div>
                                
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Instagram Link</label>
                                        <input type="text" name="social_instagram" className="sa-input" style={{ width: '100%' }} value={formData.social_instagram} onChange={handleInputChange} />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Facebook Link</label>
                                        <input type="text" name="social_facebook" className="sa-input" style={{ width: '100%' }} value={formData.social_facebook} onChange={handleInputChange} />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">YouTube Link</label>
                                        <input type="text" name="social_youtube" className="sa-input" style={{ width: '100%' }} value={formData.social_youtube} onChange={handleInputChange} />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">Review Link (Google Maps)</label>
                                        <input type="text" name="review_link" className="sa-input" style={{ width: '100%' }} value={formData.review_link} onChange={handleInputChange} />
                                    </div>
                                </div>
                            </div>

                            {/* PAYMENTS */}
                            <div className="sa-panel">
                                <h3 className="sa-panel-title"><i className="fas fa-wallet"></i> Digital Payments Settings</h3>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">UPI ID</label>
                                        <input type="text" name="upi_id" className="sa-input" style={{ width: '100%' }} placeholder="name@bank" value={formData.upi_id} onChange={handleInputChange} />
                                    </div>
                                    <div className="sa-form-group">
                                        <label className="sa-form-label">UPI Payee Name</label>
                                        <input type="text" name="upi_payee_name" className="sa-input" style={{ width: '100%' }} placeholder="Official Name" value={formData.upi_payee_name} onChange={handleInputChange} />
                                    </div>
                                </div>
                            </div>

                            <button type="submit" disabled={loading} className="sa-primary-btn" style={{ width: '100%', padding: '16px', fontSize: '1.2rem', marginBottom: '3rem', boxShadow: '0 10px 25px -5px rgba(249, 115, 22, 0.4)' }}>
                                {loading ? <><i className="fas fa-spinner fa-spin"></i> Provisioning Customer...</> : <><i className="fas fa-user-plus"></i> Create Customer Account</>}
                            </button>
                        </form>
                    </div>
        </SuperAdminLayout>
    );
};

export default AddCustomer;

